export function redirectToLogin(idUrl) {
    const ret = encodeURIComponent(window.location.href);
    window.location.href = `${idUrl}/login?return=${ret}`;
}
